import { observer } from 'mobx-react';
import React, { FC, Fragment, useState } from 'react';
import { getUserId } from '@/infrastructure/auth';
import { EditType } from '@/presentation/components/tapd-info/edit-tapd-modal';
import { BindTapdModal } from '@/presentation/components/tapd/bind-tapd-modal';
import { CreateTapdModal } from '@/presentation/components/tapd/create-tapd-modal';
import { EditTapdModal } from '@/presentation/components/tapd/edit-tapd-modal';
import { ReleaseTapdModal } from '@/presentation/components/tapd/release-tapd-modal';
import {
  TapdData,
  TapdStatusTextRender,
} from '@/presentation/components/tapd/tapd-text';
import { useStores } from '@/presentation/store';
import { FilterOptions } from '@/proto/alert';
import { Zone } from '@/proto/field';

export type TapdParams = {
  issueKey: string;
};

const priorityList = [
  { label: '紧急', value: 'urgent' },
  { label: '高', value: 'high' },
  { label: '中', value: 'medium' },
  { label: '低', value: 'low' },
  { label: '无关紧要', value: 'insignificant' },
];

export const getInitFields = (appVersionOptions?: FilterOptions[]) => ([
  {
    name: 'version_report',
    label: '发现版本',
    value: '',
    type: 'autoComplete',
    options: appVersionOptions ?? [],
  },
  {
    name: 'reporter',
    label: '创建人',
    value: getUserId(),
    type: 'userSelect',
  },
  {
    name: 'current_owner',
    label: '处理人',
    value: '',
    type: 'userSelect',
  },
  {
    name: 'priority',
    label: '优先级',
    value: priorityList[0].value,
    options: priorityList,
    type: 'select',
  },
]);

export const initVersionReportData = getInitFields()[0];
export const initReporterData = getInitFields()[1];
export const initCurrentOwnerData = getInitFields()[2];

export const TapdInfo: FC<{
  defaultProcessor: string;
  pageId: string;
  defaultAppVersion: string;
  feature: string;  // issueId
  exceptionName: string;
  crashId: string;  // lastCrashUUID
  tapdData: TapdData;   // tapdStatus tapdUrl
  issueUrl: string;   // 跳转详情url
  tapdSubmit: () => void;
  type: Zone;
}> = observer(({
  pageId, defaultAppVersion, feature,
  crashId, exceptionName, tapdData,
  issueUrl, tapdSubmit, type, defaultProcessor,
}) => {
  const [createTapdVisible, setCreateTapdVisible] = useState(false);
  const [editTapdVisible, setEditTapdVisible] = useState(false);
  const [releaseTapdVisible, setReleaseTapdVisible] = useState(false);
  const [bindTapdVisible, setBindTapdVisible] = useState(false);
  const [workspaceId, setWorkspaceId] = useState('');
  const [editType, setEditType] = useState<EditType>('add');
  const [mode, setMode] = useState('');

  const handleTapdSubmit = () => {
    setCreateTapdVisible(true);
  };

  const { getFieldOptions } = useStores().IssueStore;
  const appVersionOptions = getFieldOptions('version').filter(item => !!item.value);

  return (
    <Fragment>
      <TapdStatusTextRender
        tapdData={tapdData}
        tapdSubmit={handleTapdSubmit}
        pageId={pageId}
        deleteTapd={() => setReleaseTapdVisible(true)}
        updateTapd={() => setBindTapdVisible(true)}
      />
      <CreateTapdModal
        type={type}
        crashId={crashId}
        exceptionName={exceptionName}
        issueKey={feature}
        issueUrl={issueUrl}
        pageId={pageId}
        defaultAppVersion={defaultAppVersion}
        appVersionOptions={appVersionOptions}
        defaultProcessor={defaultProcessor}
        visible={createTapdVisible}
        onClose={() => setCreateTapdVisible(false)}
        onChangeId={(workspaceId: string) => setWorkspaceId(workspaceId)}
        openEidtModal={(editType, mode) => {
          setEditTapdVisible(true);
          setEditType(editType);
          setMode(mode);
        }}
        onSubmit={tapdSubmit}
      />
      <EditTapdModal
        appVersionOptions={appVersionOptions}
        visible={editTapdVisible}
        workspaceId={workspaceId}
        editType={editType}
        mode={mode}
        onHideEdit={() => setEditTapdVisible(false)}
        openCreate={() => setCreateTapdVisible(true)}
      />
      <ReleaseTapdModal
        visible={releaseTapdVisible}
        releaseParams={{
          issueKey: feature,
        }}
        onHide={() => setReleaseTapdVisible(false)}
        onSubmit={tapdSubmit}
      />
      <BindTapdModal
        visible={bindTapdVisible}
        bindParams={{
          issueKey: feature,
        }}
        onHide={() => setBindTapdVisible(false)}
        onSubmit={tapdSubmit}
      />
    </Fragment>
  );
});
